import { Region } from 'stores/type';
import { capitalize } from 'lodash';
import { trackProductManagement } from 'telemetry';
import { ETelemetryActionsAndLabels, ETelemetryNames } from 'telemetry/type';
import { EButtonNames } from './type';
import { ProductManagementContext } from './reducers/type';

const SupportNumber = {
    AU: '1300 045 856',
    NZ: '0800 790 009',
};

const SalesNumber = {
    AU: '03 9045 4476',
    NZ: '0800 60 69 62',
};

const RelevantCountries = {
    AU: 'Australia',
    NZ: 'New Zealand',
};

export const getFormattedSupportNumber = (region: string): string => {
    const regionCode = region in Region ? (region as Region) : Region.AU;
    return SupportNumber[regionCode];
};

export const getFormattedSalestNumber = (region: string): string => {
    const regionCode = region in Region ? (region as Region) : Region.AU;
    return SalesNumber[regionCode];
};

export const getSupportNumber = (region: string): string => {
    const supportNumber = getFormattedSupportNumber(region);
    return supportNumber && supportNumber.replace(/\s+/g, '');
};

export const getSalesNumber = (region: string): string => {
    const salesNumber = getFormattedSalestNumber(region);
    return salesNumber && salesNumber.replace(/\s+/g, '');
};

export const getRelevantCountry = (region: string): string => {
    return RelevantCountries[region as Region];
};

export const capitalise = (word: string): string => {
    return capitalize(word).replace('_', ' ');
};

export const trackViewInProductManagement = (
    productManagementContext: ProductManagementContext,
    permission: 'granted' | 'denied',
    reason?: string,
) => {
    trackProductManagement(ETelemetryNames.ProductManagement, productManagementContext, {
        action: ETelemetryActionsAndLabels.View,
        label: ETelemetryActionsAndLabels.View,
        viewData: {
            permission,
            reason,
        },
    });
};

export const trackClickEventInProductManagement = (
    productManagementContext: ProductManagementContext,
    buttonName: EButtonNames,
) => {
    trackProductManagement(ETelemetryNames.ProductManagement, productManagementContext, {
        action: ETelemetryActionsAndLabels.Click,
        label: ETelemetryActionsAndLabels.Click,
        clickData: {
            buttonName,
        },
    });
};
